import { useState } from 'react'
import { Popover } from '@mantine/core'
import Picker from '@emoji-mart/react'
import data from '@emoji-mart/data'

export default function EmojiPickerButton({ onSelect, onClose, placement = 'top-end' }) {
  const [opened, setOpened] = useState(false)

  function close() {
    setOpened(false)
    onClose?.()
  }

  function handleEmojiSelect(emoji) {
    const char = emoji?.native || ''
    if (char && onSelect) onSelect(char)
    close()
  }

  return (
    <Popover opened={opened} onChange={(v) => { setOpened(v); if (!v) onClose?.() }} position={placement} withArrow shadow="md">
      <Popover.Target>
        <button
          type="button"
          className="EmojiTrigger"
          aria-label="Insert emoji"
          onClick={() => setOpened((v) => !v)}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mantine-color-gray-1, #fff)'
          }}
          title="Insert emoji"
        >
          <span className="material-symbols-outlined">sentiment_satisfied</span>
        </button>
      </Popover.Target>
      <Popover.Dropdown style={{ padding: 0 }}>
        <Picker data={data} onEmojiSelect={handleEmojiSelect} theme="dark" navPosition="top" previewPosition="none" autoFocus />
      </Popover.Dropdown>
    </Popover>
  )
}
